import API_URLS from '../links';

export const getMembers = (creds,gymId) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.GET_MEMBERS + `/${gymId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          access_token: creds.access_token
        }
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};

export const addUpdateMember = (creds, formData) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.ADD_MEMBER, {
        method: 'POST',
        headers: {
          access_token: creds.access_token
        },
        body: formData
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};

export const updateMember = (creds, formData, id) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.UPDATE_MEMBER + '/' + id, {
        method: 'PUT',
        headers: {
          access_token: creds.access_token
        },
        body: formData
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};

export const deleteMember = (creds, data) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.DELETE_MEMBER, {
        method: 'DELETE',
        headers: {
          access_token: creds.access_token,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};

export const sendMessageToMember = (creds, body) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.MESSAGE_MEMBER, {
        method: 'POST',
        headers: {
          access_token: creds.access_token,
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};
